import { ApolloClient, InMemoryCache } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { config } from '@config/config';

import { createLink } from './createLink';

let client: ApolloClient;

export const createApolloClient = () => {
  if (!client) {
    client = new ApolloClient({
      link: createLink(),
      cache: new InMemoryCache(),
      assumeImmutableResults: true,
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          nextFetchPolicy: 'cache-first',
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'network-only',
          errorPolicy: 'all',
        },
      },
    });

    return client;
  }

  return client;
};

export const resetApolloLink = async (accessToken: string) => {
  client.setLink(createLink({ accessToken }));
};

export const setErrorToken = () => {
  client.setLink(createLink({ accessToken: 'test' }));
};

if (config.NODE_ENV !== 'production') {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}
